import { render } from "./TableChart.vue?vue&type=template&id=0451eec9&scoped=true"
import script from "./TableChart.vue?vue&type=script&lang=js"
export * from "./TableChart.vue?vue&type=script&lang=js"

import "./TableChart.vue?vue&type=style&index=0&id=0451eec9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0451eec9"]])

export default __exports__